import React, {useEffect, useState} from 'react';
import {
  Typography,
  FormControl,
  FormLabel,
  Box,
  Select,
  MenuItem,
  FormGroup,
  FormHelperText
} from '@mui/material';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {Controller, useFormContext} from 'react-hook-form';
interface datefield {
  field: any;
  name?: string;
}
const dateFormats = [
  'mm-dd-yyyy',
  'dd-mm-yyyy',
  'dd-MMM-yyyy',
  'dd-MMM-yy',
  'mm/dd/yyyy',
  'dd/mm/yyyy',
  'MM-dd-yyyy',
  'yyyy-mm-dd',
  'yyyy/mm/dd',
  'dd.mm.yyyy'
];

const Datefromto: React.FC<datefield> = ({field, name}) => {
  const [dateFormat, setDateFormat] = useState<string>(field.value.dateformat);
  const {control} = useFormContext();
  useEffect(() => {
    setDateFormat(field.value.dateformat);
  }, [field.value]);
  return (
    <FormControl component="fieldset" margin="normal">
      <FormLabel component="legend">Date Settings</FormLabel>
      <Box
        sx={{
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '16px',
          mt: 2
        }}>
        <Controller
          name={name || ''}
          control={control}
          render={({field, fieldState: {error}}) => (
            <FormGroup>
              <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
                <Typography variant="body1" sx={{flex: 1}}>
                  Date Format
                </Typography>
                <Select
                  value={dateFormat}
                  onChange={e => {
                    //given the field.value.dateformat  to update the existing dateformat donot add the mew dateFormat
                    field.onChange({
                      ...field.value,
                      dateformat: e.target.value
                    });
                    setDateFormat(e.target.value as string);
                  }}
                  sx={{flex: 2}}>
                  {dateFormats.map(format => (
                    <MenuItem key={format} value={format}>
                      {format}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mt: 2
                  }}>
                  {
                    //use the Datepicker component to select the start and end date and update the field
                  }
                  <DatePicker
                    label="Start Date"
                    value={field.value.startDate}
                    onChange={date => {
                      field.onChange({...field.value, startDate: date});
                    }}
                    format={dateFormat}
                    disableFuture
                  />
                  <DatePicker
                    label="End Date"
                    value={field.value.stopDate}
                    onChange={e =>
                      field.onChange({...field.value, stopDate: e})
                    }
                    format={dateFormat}
                    disableFuture
                  />
                </Box>
                {/* <RHFTextField
              name={`.startDate`}
              label="Start Date"
              type="date"
              defaultValue={startDate}
              required
            /> */}
              </LocalizationProvider>
              {error && (
                <FormHelperText sx={{fontSize: '1rem !important'}} error>
                  {error &&
                    ((error as any)?.startDate?.message ||
                      (error as any)?.stopDate?.message)}
                </FormHelperText>
              )}
            </FormGroup>
          )}
        />
      </Box>
    </FormControl>
  );
};

export default Datefromto;
